module.exports = __webpack_public_path__ + "static/media/C-CLIVI24.31a0077a.jpg";